import React, { useState, useRef } from 'react'
import { Zoom } from 'react-slideshow-image'

import arrow from '../../../assets/images/svg_icons/arrow.svg'

const AnimalHealth = props => {
  let { animal_health } = props
    , slideRef = useRef(null)
    , [currentSlide, setCurrentSlide] = useState(0)

  const zoomInProperties = {
    autoplay: animal_health.length > 1,
    indicators: false,
    arrows: false,
    scale: 1.4
  }

  const onChangeSlide = (previous, next) => {
    setCurrentSlide(next)
  }

  return <div className='products__animal-health'>
    <div className='products__animal-info transition'>
      <div className='gray-color' dangerouslySetInnerHTML={{ __html: animal_health.paragraphs }} />
      <a className='product__link' rel='noreferrer' href={animal_health.hyperlink.link} target='_blank'>
        {animal_health.hyperlink.label}
        <img className='arrow-left' src={arrow} alt='flecha' />
      </a>
    </div>
    <div className='products__slider transition'>
      <div className='products__slider-container'>
        <Zoom ref={slideRef} {...zoomInProperties} onChange={onChangeSlide}>
          {
            animal_health.gallery.map((item, index) => (
              <div key={index} className='products__slider-image' style={{ background: `url(${item.image})` }}>
              </div>
            ))
          }
        </Zoom>
      </div>
      {
        Boolean(animal_health.length > 1) &&
        <div className='products__slider-bullets-container'>
          {
            animal_health.gallery.map((item, index) => <div
              key={index}
              className={`bullet ${currentSlide === index ? 'current' : ''} transition`}
              onClick={() => slideRef.current.goTo(index)} />)
          }
        </div>
      }
    </div>
  </div>
}

export default AnimalHealth